/* unplugin-vue-components disabled */import { render } from "./Home.vue?vue&type=template&id=4e1e06aa&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=4e1e06aa&scoped=true&lang=scss"

import exportComponent from "D:\\00JH-项目\\钧舵机器人\\en\\jodell_robotics\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1e06aa"]])

export default __exports__